// extracted by mini-css-extract-plugin
module.exports = {"header":"AuthHeader_header__VrmNh","anchor_container":"AuthHeader_anchor_container__38uQo","title":"AuthHeader_title__3ALQh"};